import request from 'superagent';
import Model from '../model';
import * as actions from './actions'
import {store} from '/app/src/store';
import { toast } from 'react-toastify';
import {List} from 'immutable';

import {FAQSelector, NetworkSelector} from '/app/src/model/selectors'

class FAQ extends Model {
    constructor(){
        super()
        this.selector = FAQSelector
    }

    requestById(id) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()

            dispatch(actions.faqReadRequest(true));
            return request
                .post(`${url}/v2/api/faq/item/read`)
                .send({'faq_id': id})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        //Reducer handles only lists of FAQ.
                        dispatch(actions.faqReadSuccess(List([res.body.faq])))
                    } else {
                        dispatch(actions.faqReadFailure(err, res))
                        toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')
                    }
                });
        }
    }

    read() {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()

            dispatch(actions.faqReadRequest(true));
            return request
                .post(`${url}/v1/company/faq/get`)
                .send({})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        const QnA = res.body.faqs;
                        QnA.sort(function(a, b) {
                            return (a.id - b.id);
                        });
                        dispatch(actions.faqReadSuccess(QnA))
                    } else {
                        dispatch(actions.faqReadFailure(err, res))
                        toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')
                    }
                });
        }
    }

    create(question, answer) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.faqCreateRequest(true));

            return request
                .post(`${url}/v1/company/faq/create`)
                .send({
                    question: question,
                    answer: answer
                })
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        const QnA = res.body.faqs;

                        QnA.sort(function(a, b) {
                            return (a.id - b.id);
                        });

                        //store.dispatch(faqCreated(QnA));
                        dispatch(actions.faqCreateSuccess(QnA))
                        toast.success('FaQ skapades!')
                    } else {
                        dispatch(actions.faqCreateFailure(err, res))
                        toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')
                    }
                });
        }
    }
    delete(id) {
        return (dispatch) => {
            const url = this.url();
            const token = this.token()
            dispatch(actions.faqDeleteRequest(true));

            return request
                .post(`${url}/v1/company/faq/delete`)
                .send({
                    faq_id: id
                })
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        const QnA = res.body.faqs;
                        QnA.sort(function(a, b) {
                            return (a.id - b.id);
                        });
                        store.dispatch(actions.faqDeleteSuccess(QnA));
                        toast.success('FAQ togs bort!')
                    } else {
                        store.dispatch(actions.faqDeleteFailure(err, res));
                        toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')
                    }
                });
        }
    }
    update(id, question, answer) {
        return (dispatch) => {
            const url = this.url();
            const token = this.token()
            dispatch(actions.faqUpdateRequest(true));

            return request
                .post(`${url}/v1/company/faq/update`)
                .send({
                    question: question,
                    answer: answer,
                    faq_id: id
                })
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200){
                        const QnA = res.body.faqs;
                        QnA.sort(function(a, b) {
                            return (a.id - b.id);
                        });
                        store.dispatch(actions.faqUpdateSuccess(QnA));
                        toast.success('FaQ updaterades!')
                    }
                    else{
                        store.dispatch(actions.faqUpdateFailure(err, res));
                        toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')
                    }
                });
        }
    }

    setCurrentItem(id){
        const selectorFunction = (state) => {
            return {
                'current': FAQSelector.getCurrentItem(state)
            }
        }
        const dispatchFunction = (id) => {
            return (dispatch) => {
                dispatch({
                    type: 'faq set current item',
                    payload: {
                        'id': id
                    }
                })
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    getCategoriesRequest(){
        const selectorFunction = (state) => {
            return {
                'categories': FAQSelector.getCategories(state),
                'network': NetworkSelector.get(state, 'CATEGORIES_GET'),
            }
        }

        const dispatchFunction = ()=> {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'CATEGORIES_GET_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/categories/get`)
                    .send({})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .end((err, res) => {
                        if (res.statusCode === 200) {
                            dispatch({
                                type: 'CATEGORIES_GET_SUCCESS',
                                payload: res.body.categories
                            })
                        }else{
                            dispatch({type: 'CATEGORIES_GET_ERROR', error: err});

                        }
                    });
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    removeCategoryRequest(){
        const selectorFunction = (state) => {
            return {
                'categories': FAQSelector.getCategories(state),
                'network': NetworkSelector.get(state, 'CATEGORY_REMOVE'),
            }
        }

        const dispatchFunction = (categoryId) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'CATEGORY_REMOVE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/category/remove`)
                    .send({category_id: categoryId})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'CATEGORY_REMOVE_SUCCESS',
                            payload: res.body.categories
                        })
                    })
                    .catch(err => {
                        dispatch({type: 'CATEGORY_REMOVE_FAILURE', error: err});
                    })
            }
        }
        return {
            selector: selectorFunction, dispatcher: dispatchFunction
        }
    }

    createCategoryRequest(){
        const selectorFunction = (state) => {
            return {
                'categories': FAQSelector.getCategories(state),
                'network': NetworkSelector.get(state, 'CATEGORY_CREATE'),
            }
        }

        const dispatchFunction = (category, imgSrc) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'CATEGORY_CREATE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/category/create`)
                    .send({category, imgSrc})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'CATEGORY_CREATE_SUCCESS',
                            payload: res.body.categories
                        })
                    })
                    .catch(err => {
                        dispatch({type: 'CATEGORY_CREATE_FAILURE', error: err});
                    })
            }
        }
        return {
            selector: selectorFunction, dispatcher: dispatchFunction
        }
    }

    createItemRequest(){


        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'FAQ_CREATE'),
            }
        }

        const dispatchFunction = (question, answer, authorName, authorImg, categoryId) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'FAQ_CREATE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/item/create`)
                    .send({question: question, answer: answer, author_name: authorName, author_img: authorImg, category_id: categoryId})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            payload: res.body,
                            type: 'FAQ_CREATE_SUCCESS'
                        })
                    })
                    .catch(err => {
                        dispatch({type: 'FAQ_CREATE_FAILURE', error: err});
                    })
            }
        }

        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    removeItemRequest(){

        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'FAQ_REMOVE'),
            }
        }

        const dispatchFunction = (faqId) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'FAQ_REMOVE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/item/remove`)
                    .send({faq_id: faqId})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            payload: res.body,
                            type: 'FAQ_REMOVE_SUCCESS'
                        })
                        dispatch()
                    })
                    .catch(err => {
                        dispatch({type: 'FAQ_REMOVE_FAILURE', error: err});
                    })
            }
        }

        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    updateCategoryRequest(){

        const selectorFunction = (state) => {
            return {
                'categories': FAQSelector(state, 'categories'),
                'network': NetworkSelector.get(state, 'CATEGORY_UPDATE'),
            }
        }
        const dispatchFunction = (categoryId, updateData) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'CATEGORY_UPDATE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/category/update`)
                    .send({category_id: categoryId, updates: updateData})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'CATEGORY_UPDATE_SUCCESS',
                            payload: res.body.categories
                        })

                    })
                    .catch(err => {
                        dispatch({type: 'CATEGORY_UPDATE_FAILURE', error: err});
                    })
            }
        }
        return {
            selector: selectorFunction, dispatcher: dispatchFunction
        }
    }

    updateCategoriesRequest(){

        const selectorFunction = (state) => {
            return {
                'categories': FAQSelector.getCategories(state),
                'network': NetworkSelector.get(state, 'CATEGORIES_UPDATE'),
            }
        }
        const dispatchFunction = (categories) => {

            const url = this.url()
            const token = this.token()
            return (dispatch) => {
                dispatch({type: 'CATEGORIES_UPDATE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/categories/update`)
                    .send({categories})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'CATEGORIES_UPDATE_SUCCESS',
                            payload: res.body.categories
                        })
                        toast.success('Ändringar sparad');
                    })
                    .catch(err => {
                        dispatch({type: 'CATEGORIES_UPDATE_FAILURE', error: err});
                    })
            }
        }
        return {
            selector: selectorFunction, dispatcher: dispatchFunction
        }
    }

    updateItemRequest(){
        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'FAQ_UPDATE'),
            }
        }

        const dispatchFunction = (faq_id, updates) => {

            const url = this.url()
            const token = this.token()

            console.log('updates', updates);
            return (dispatch) => {
                dispatch({type: 'FAQ_UPDATE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/item/update`)
                    .set('Authorization', 'Bearer ' + token)
                    .send({'id': faq_id, ...updates})
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'FAQ_UPDATE_SUCCESS',
                            payload: res.body
                        })
                        toast.success('Ändringar sparad');
                    })
                    .catch(err => {
                        dispatch({type: 'FAQ_UPDATE_FAILURE', error: err});
                    })
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    updateItemsRequest(){

        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'FAQS_UPDATE'),
            }
        }

        const dispatchFunction = (faqs) => {

            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'FAQS_UPDATE_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/items/update`)
                    .set('Authorization', 'Bearer ' + token)
                    .send({faqs})
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'FAQS_UPDATE_SUCCESS',
                            payload: res.body
                        })
                    })
                    .catch(err => {
                        dispatch({type: 'FAQS_UPDATE_FAILURE', error: err});
                    })
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }



    readItemsRequest(){

        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'faq read'),
            }
        }

        const dispatchFunction = () => {

            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'faq read success'});
                return request
                    .post(`${url}/v2/api/faq/items/read`)
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'FAQ_READ_SUCCESS',
                            payload: res.body.faqs
                        })
                    })
                    .catch(err => {
                        dispatch({type: 'FAQ_READ_FAILURE', error: err});
                    })
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }


    readItemsByCategoryRequest(){

        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'FAQ_READ_BY_CATEGORY'),
            }
        }

        const dispatchFunction = (categoryId) => {

            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch({type: 'FAQ_READ_BY_CATEGORY_REQUEST'});
                return request
                    .post(`${url}/v2/api/faq/category/items/read`)
                    .set('Authorization', 'Bearer ' + token)
                    .send({'category_id': categoryId})
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .then(res => {
                        dispatch({
                            type: 'FAQ_READ_BY_CATEGORY_SUCCESS',
                            payload: res.body
                        })
                    })
                    .catch(err => {
                        console.log(err);
                        dispatch({type: 'FAQ_READ_BY_CATEGORY_FAILURE', error: err});
                    })
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    setFaqCurrentPayload(payload) {
        const dispatchFunction = (payload) => {
            return (dispatch) => {
                dispatch(actions.faqSetCurrentPayload(payload))
            }
        }
        return {dispatcher: dispatchFunction}
    }

    setFaqCurrentItem(id) {
        const dispatchFunction = (payload) => {
            return (dispatch) => {
                dispatch(actions.faqSetCurrentItem(payload))
            }
        }
        return {dispatcher: dispatchFunction}
    }

}


export default new FAQ();



// WEBPACK FOOTER //
// ./src/model/FAQ/model.js